import { formatDisplayDate } from '@/utils/date';

/** The date range a report covers, worded as the API words it for the reports that return it. */
export function pcmpReportPeriodLabel(dateFrom: string | undefined, dateTo: string | undefined) {
  if (!dateFrom && !dateTo) return 'All to date';
  const from = dateFrom ? formatDisplayDate(dateFrom) : 'Beginning';
  const to = dateTo ? formatDisplayDate(dateTo) : 'Today';
  return `${from} - ${to}`;
}
